export default __webpack_public_path__ + "static/media/Girdle of the Inconceivable.2c76919e.jpg";